export const makeServiceUrl = (service: string, path: string) => (process.env.REACT_APP_MLG_SERVICE_URL || '').replace('%s', service) + path;